import { render, staticRenderFns } from "./navigationXQ.vue?vue&type=template&id=31b795d1&scoped=true"
import script from "./navigationXQ.vue?vue&type=script&lang=js"
export * from "./navigationXQ.vue?vue&type=script&lang=js"
import style0 from "./navigationXQ.vue?vue&type=style&index=0&id=31b795d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b795d1",
  null
  
)

export default component.exports